import type { ReactNode } from 'react';
import { useBranding } from '../lib/branding.tsx';

// Standalone branded wrapper for the public visitor portal (no auth).
export function VisitorShell({ children }: { children: ReactNode }) {
  const { branding } = useBranding();
  const brandName = branding.companyName?.replace(/ Safety.*$/i, '') ?? 'Locate2u';
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b bg-white" style={{ borderColor: '#E2E8F0' }}>
        <div className="mx-auto flex max-w-xl items-center gap-3 px-5 py-4">
          {branding.logoUrl ? (
            <img src={branding.logoUrl} alt={brandName} className="h-8 w-auto" />
          ) : (
            <span className="text-base font-bold tracking-tight" style={{ color: 'var(--brand-primary)' }}>
              {brandName}
            </span>
          )}
          <span className="text-sm text-slate-500">Visitor sign-in</span>
        </div>
      </header>
      <main className="mx-auto max-w-xl px-5 py-6">
        <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">{children}</div>
      </main>
    </div>
  );
}
